export const clientStatsFixture = [
  ['Clients actifs', '1 248', '+ 5 %', 'success'],
  ['Résidentiel', '987', '79 %', 'info'],
  ['Commercial', '261', '21 %', 'purple'],
  ['Clients à renouveler', '132', '+ 12 %', 'warning'],
  ['Suspensions', '28', '− 4 %', 'danger'],
  ['Solde moyen', '1 248 $', '+ 8 %', 'warning'],
] as const

export const clientsFixture = [
  ['Marché Lambert', 'Commercial', '1540, Rue des Pins', 'Actif', 'CT-2024-1540', 'Route 5A', '1 240,00 $'],
  [
    'Centre Médical St-Jérôme',
    'Commercial',
    '850, Rue Labelle',
    'Actif',
    'CT-2024-0850',
    'Route 3B',
    '2 450,00 $',
  ],
  [
    'Pharmacie Brunet',
    'Commercial',
    '112, Rue Saint-Georges',
    'Suspendu',
    'CT-2023-112',
    'Route 7C',
    '−320,00 $',
  ],
  [
    'Les Entreprises LM inc.',
    'Commercial',
    '2121, Boul. des Laurentides',
    'À renouveler',
    'CT-2023-2121',
    'Route 7C',
    '560,00 $',
  ],
  [
    'Jardins de la Rive',
    'Résidentiel',
    '78, Rue des Érables',
    'Actif',
    'CT-2024-078',
    'Route 2A',
    '180,00 $',
  ],
  [
    'Michel Roy Résidence',
    'Résidentiel',
    '345, Rue de la Paix',
    'Actif',
    'CT-2024-345',
    'Route 1B',
    '180,00 $',
  ],
  [
    'Pavillon Lafontaine',
    'Commercial',
    '500, Rue Parent',
    'À renouveler',
    'CT-2023-500',
    'Route 3B',
    '875,00 $',
  ],
  [
    'Syndicat Copropriété des Cèdres',
    'Résidentiel',
    '200, Rue des Cèdres',
    'Suspendu',
    'CT-2023-200',
    'Route 5B',
    '−95,00 $',
  ],
  // Un Client sans Contrat ni adresse : la liste réelle en contient, et la
  // carte doit rester lisible sans ces deux informations.
  ['Gabriel Cayer', 'Résidentiel', '', 'Sans contrat', '', '', '—'],
] as const

export const clientNotesFixture = [
  ['Jean-François Roy', 'Client satisfait du service lors de la dernière visite.', '8 janv. 2025 à 09:42'],
  [
    'Sophie Martin',
    'Souci avec l’accumulation près de la boîte aux lettres corrigé.',
    '5 janv. 2025 à 15:18',
  ],
  ['Marc-André G.', 'Renouvellement confirmé pour la saison 2024–2025.', '2 déc. 2024 à 11:05'],
] as const
